import { asyncModule } from '../../utils/async-module';
import { asyncPreactWidget } from '../../utils/async-preact-widget';
import * as JSModules from '../../components/modules';
import * as preactWidgets from '../../preact/widgets';
import { commonActions } from '../../global-store/subjects/common';
import { embedsSelectors } from '../../components/embeds/vendors';
import { hasLmpTab } from '../../utils/aem-utils';

export const asyncOutbrain = () => {
  const $outbrainMain = document.querySelector('.j-outbrain');
  const $outbrainInText = document.querySelector('.j-outbrain-intext');
  if ($outbrainMain || $outbrainInText) {
    const { start, getInit, error } = asyncModule(JSModules.outbrainModule);
    start();
    import('../../components/outbrain/outbrain').then(getInit({ $outbrainMain, $outbrainInText })).catch(error);
  }
};

export const asyncTwitterLib = () => {
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.twitterLibModule);
  if (shouldInit()) {
    start();
    import('../../components/social-scripts/twitter-lib').then(getInit()).catch(error);
  }
};

export const asyncSkySocialShare = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.socialShare);
  if (isOnPage() || hasLmpTab()) {
    start();
    import(`../../preact/widgets/social-share`).then(hydrate).catch(error);
  }
};

export const asyncAutoPushNotifications = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.autoPushNotifications);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/auto-push-notifications`).then(hydrate).catch(error);
  } else {
    commonActions.setPushNotificationInDialogShow(false);
  }
};

export const asyncEmbeds = () => {
  const isEmbedInPage = Object.values(embedsSelectors)
    .map((embedSelector) => document.querySelector(embedSelector))
    .some((node) => Boolean(node));
  if (isEmbedInPage) {
    const { start, getInit, error } = asyncModule(JSModules.embedsModule);
    start();
    import('../../components/embeds/embeds').then(getInit()).catch(error);
  }
};
